import EnquiryConstants from './EnquiryConstants'

//export action creators here

export function postEnquiry(enquiryId, data) {
    return {
        types: [
            EnquiryConstants.POST_ENQUIRY_REQUEST,
            EnquiryConstants.POST_ENQUIRY_SUCCESS,
            EnquiryConstants.POST_ENQUIRY_FAIL
        ],
        payload: {
            request:{
               // url:'http://localhost/test/form-mailer-s/'+ enquiryId,
               // url:'https://formmailer.protege.a2hosted.com/form-mailer-s/'+ enquiryId,
                url: 'https://formmailer.hustleandbustle.co/form-mailer-s/'+ enquiryId,
                method:"post",
                data: data
            }
        }
    }
}

export default {
    postEnquiry
}



// WEBPACK FOOTER //
// ./src/redux-modules/enquiry/EnquiryActionCreators.js